import { imageURL } from "./constants";

/**
 * כשהאדמין רץ על דומיין אחר מזה של ה־API (למשל admin.we-me.app מול www.we-me.app),
 * טעינת `<img src="https://www.../static/...">` נחסמת ע״י ORB (NotSameOrigin) - אין טעם לבקש.
 */
export function isProfileImageSameOriginAsPage(): boolean {
  if (typeof window === "undefined" || typeof globalThis.ENV === "undefined") {
    return true;
  }
  try {
    const apiOrigin = new URL(globalThis.ENV.serverBaseUrl).origin;
    return window.location.origin === apiOrigin;
  } catch {
    return true;
  }
}

/** מזהה תמונה ל־src רק כשאפשר לטעון מאותו מקור; אחרת undefined → אווטאר עם ראשי תיבות בלבד. */
export function profileImageSrcForBrowser(
  imageId?: string | null,
): string | undefined {
  if (imageId == null || imageId === "") return undefined;
  if (imageId.startsWith("/")) return imageId;
  if (!isProfileImageSameOriginAsPage()) return undefined;
  return imageURL(imageId);
}
